	import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/react';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import Button from '../../components/ui/Button';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../components/ui/Dropdown';
import Modal, { ModalBody, ModalHeader } from '../../components/ui/Modal';
import SimpleLoader from '../../components/ui/SimpleLoader';
import Tooltip from '../../components/ui/Tooltip';
import { useApiReload } from '../../context/apiRelaod';
import { useAuth } from '../../context/authContext';
import { getCalendarDetails, getCalendarDetailsByday } from '../../services/apiService';
import { dateFormat } from '../../utils/priceFormat.util';

	export function CalendarDate() {
		const [isModalOpen, setIsModalOpen] = useState(false);
		const [selectedEvent, setSelectedEvent] = useState<any>(null);
		const [daydata, setDaydata] = useState<any>(null);
		const [currentMonth, setCurrentMonth] = useState<number>(new Date().getMonth());
		const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());
		// console.log(daydata);
		const { calendarCall, calendarRespone } = getCalendarDetails();
		const { calendarCallDay, calendarResponeDay, loading } = getCalendarDetailsByday();
		const { patientID } = useApiReload();
		const { onLogout } = useAuth();
		const navigate = useNavigate();

		useEffect(() => {
			if (isModalOpen) {
				const yearStr = String(currentYear); // Convert year to string
				const monthStr = String(currentMonth).padStart(2, '0');
				calendarCall(yearStr, monthStr ?? '0').subscribe({
					next: (e) => {},
					error: (er) => {
						if (er?.status === 409) {
							onLogout(er?.status);
						}
						console.log(er);
					},
				});
			}

			// Use the correct year and month
		}, [currentYear, currentMonth, patientID?.id, isModalOpen]);

		const handleOpenModal = () => {
			setIsModalOpen(true);
		};

		const handleCloseModal = () => {
			setIsModalOpen(false);
			setSelectedEvent(null);
		};

		const handleDatesSet = (dateInfo: any) => {
			const start = dateInfo.view.currentStart;
			const end = dateInfo.view.currentEnd;

			const month = start.getMonth();
			const year = start.getFullYear();

			setCurrentMonth(month);
			setCurrentYear(year);
		};

		const handleDetailbyday = (info: any) => {
			const clickedDate = new Date(info.date);
			const yyyy = clickedDate.getFullYear().toString();
			const mm = clickedDate.getMonth().toString();
			const dd = clickedDate.getDate().toString();

			calendarCallDay(yyyy, mm, dd).subscribe({
				next: (v) => {
					setDaydata(v.data.patients);
				},
				error: (e) => {
					if (e?.status === 409) {
						onLogout(e?.status);
					}
					console.log(e);
				},
			});
		};

		const transformedEvents = calendarRespone?.data?.map(
			(item: { day: number; casesCount: number }) => ({
				title: `Notes: ${item.casesCount}`,
				start: new Date(currentYear, currentMonth, item.day).toISOString(),
				allDay: true,
			}),
		);
		const debouncedHandleDetail = useCallback(
			debounce((info) => handleDetailbyday(info), 1000, { leading: true, trailing: true }),
			[],
		);
		return (
			<div id='calendar' className='drop-shadow-none'>
				<Tooltip text='Calendar' placement='bottom-end'>
					<Icon
						data-component-name='Nav/NavIcon'
						icon='HeroCalendarDays'
						className={'w-6 flex-none text-2xl'}
						onClick={handleOpenModal}
					/>
				</Tooltip>
				<Modal
					isOpen={isModalOpen}
					setIsOpen={setIsModalOpen}
					isCentered
					size='sm'
					className='relative transition-all duration-500'>
					<ModalHeader setIsOpen={setIsModalOpen}>Event Details</ModalHeader>
					<ModalBody>
						<div className='model-border-parent'>
							<FullCalendar
								plugins={[dayGridPlugin, interactionPlugin]}
								initialView='dayGridMonth'
								weekends={true}
								events={transformedEvents}
								datesSet={handleDatesSet}
								dateClick={(info) => {
									debouncedHandleDetail(info);
								}}
							/>
						</div>
						{loading && <SimpleLoader />}

						<div
							className={`no-scrollbar model-border absolute top-0 h-full w-1/2 overflow-y-auto rounded-[0.5rem] bg-white transition-transform duration-500 ease-in-out ${daydata?.length > 0 ? 'inset-x-[40.5rem] translate-x-0 opacity-100' : 'pointer-events-none -translate-x-full opacity-0'} `}>
							<div className='border-b p-3 font-semibold text-gray-700'>Case Details</div>
							{daydata?.length > 0 ? (
								daydata?.map((p: any, index: any) => (
									<div key={index}>
										<div className='border-b p-3 font-semibold text-gray-700'>
											Patient Name: {p.patientName}
										</div>

										{p.cases.map((c: any, cIndex: any) => (
											<div className='my-3'>
												<div
													key={c.id}
													className={`} flex min-w-[250px] cursor-pointer items-center gap-2 rounded p-3 shadow`}
													// onClick={() => handleCaseClick(c.id)}
												>
													<p className='bg flex h-11 w-2 rounded-lg bg-blue-500'></p>

													<div>
														<p className='w- font-semibold text-blue-950'>
															Case Id: {c.caseName}
														</p>
														<p className='text-black-400 mb-0 text-sm'>
															Created At: {dateFormat(c?.createdAt, true)}
														</p>
													</div>
													<Dropdown>
														<DropdownToggle hasIcon={false}>
															<Button icon='HeroChevronDown'/>
														</DropdownToggle>
														<DropdownMenu>

														{c.notelist.length > 0 ? c.notelist.map((n: any) => (
															<DropdownItem onClick={() => { setIsModalOpen(false);	navigate(
																`/patients/${p.patientId}/cases/${c.id}/soap/${n.id}`,
																{
																	state: {
																		patient: p.patientId,
																		caseData: c.id,
																		soapData: n,
																		selectedSoapNoteId: n.id,
																	},
																})}}>
 															Note Type: {n.noteType}
															</DropdownItem>
														)):<DropdownItem >
															No Note Found
													   </DropdownItem> }
														</DropdownMenu>
													</Dropdown>
												</div>

											</div>
										))}
									</div>
								))
							) : (
								<div
									className={`bg-blue-300' } w-full cursor-pointer rounded p-3 text-center`}>
									<p className='w- font-semibold text-blue-950'>No Case Found </p>
								</div>
							)}
						</div>
					</ModalBody>
				</Modal>
			</div>
		);
	}
